export const MainMenuItemDefProps = {
  linkTo: '/linkTo',
  linkText: 'MainMenuItem',
  addClasses: 'MainMenuItem_mw271'
};